<template>
  <v-container fluid class="mr-6">
    <v-row class="text-center" v-show="loading">
      <v-progress-circular
        class="mx-auto loader"
        indeterminate
        color="orange"
        size="75"
      ></v-progress-circular>
    </v-row>

    <v-row v-show="!loading">
      <v-col cols="12" class="text-right">
        <v-btn
          class="mx-2 orange--text"
          fab
          color="white"
          @click="dialogUpload = true"
        >
          <v-icon dark>mdi-upload</v-icon>
        </v-btn>
        <v-btn class="mx-2" fab dark color="orange" @click="openDialog">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-show="!loading">
      <v-col>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="resources"
          :search="term"
          @click:row="edit"
          show-select
        >
          <template v-slot:top>
            <v-row align="center" class="mx-6">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="term"
                  label="Search"
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="text-right">
                <v-btn
                  v-show="selected.length > 0"
                  color="red"
                  class="white--text"
                  @click="remove"
                >
                  <v-progress-circular
                    v-if="deleting"
                    indeterminate
                    color="white"
                  ></v-progress-circular>
                  <span v-else>Delete</span>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogUpload" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          Bulk Upload Resources
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input v-model="file" label="File"></v-file-input>
                <label>
                  CSV Format: name, address, city, state, zip, phone, website,
                  description, type, stage
                </label>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialogUpload = false">Cancel</v-btn>
          <v-btn text color="orange" @click="upload">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          Add/Edit Resource
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="resource.name"
                  label="Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="resource.address"
                  label="Address"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="resource.city"
                  label="City"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-autocomplete
                  v-model="resource.state"
                  :items="states"
                  label="State"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="resource.zip" label="Zip"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="resource.phone"
                  label="Phone"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="resource.email"
                  label="Email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="resource.website"
                  label="Website"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-select
                  v-model="resource.types"
                  label="Type"
                  :items="types"
                  multiple
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-select
                  v-model="resource.stages"
                  label="Stage"
                  :items="stages"
                  multiple
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="resource.description"
                  label="Description"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn v-show="editing" text color="red" @click="remove">
            <v-progress-circular
              v-if="deleting"
              indeterminate
              color="red"
            ></v-progress-circular>
            <span v-else>Delete</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialog = false">Cancel</v-btn>
          <v-btn text color="orange" @click="save">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Papa from "papaparse";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      deleting: false,
      dialog: false,
      dialogUpload: false,
      editing: false,
      file: null,
      headers: [
        { text: "Name", value: "name" },
        { text: "City", value: "city" },
        { text: "State", value: "state" },
        { text: "Address", value: "address" },
        { text: "Zip", value: "zip" },
        { text: "Phone", value: "phone" },
        { text: "Website", value: "website" },
        { text: "Email", value: "email" },
      ],
      loading: true,
      resource: {
        name: null,
        city: null,
        state: null,
        address: null,
        zip: null,
        phone: null,
        email: null,
        website: null,
        description: null,
        stages: null,
        types: null,
      },
      saving: false,
      selected: [],
      term: null,
    };
  },
  computed: {
    ...mapGetters({
      resources: "resources/getResources",
      stages: "resources/getStages",
      states: "resources/getStates",
      types: "resources/getTypes",
    }),
  },
  methods: {
    ...mapActions({
      createResource: "resources/createResource",
      deleteResource: "resources/deleteResource",
      listResources: "resources/listResources",
      updateResource: "resources/updateResource",
    }),
    edit(item) {
      this.resource = item;
      this.editing = true;
      this.dialog = true;
    },
    openDialog() {
      this.resource = {
        name: null,
        city: null,
        state: null,
        address: null,
        zip: null,
        phone: null,
        email: null,
        website: null,
        description: null,
        stages: null,
        types: null,
      };
      this.editing = false;
      this.dialog = true;
    },
    async remove() {
      this.deleting = true;
      const removed = this.selected.map(async resource => {
        await this.deleteResource(resource.id);
      });
      await Promise.all(removed);
      await this.listResources();
      this.selected = [];
      this.dialog = false;
      this.deleting = false;
    },
    async save() {
      this.saving = true;
      if (this.resource.id) {
        await this.updateResource(this.resource);
      } else {
        await this.createResource(this.resource);
      }
      await this.listResources();
      this.dialog = false;
      this.saving = false;
    },
    upload() {
      this.saving = true;
      Papa.parse(this.file, {
        header: true,
        skipEmptyLines: true,
        step: async row => {
          let stageIndices = [];
          let typeIndices = [];
          let rowStages = [];
          let rowTypes = [];
          if (row.data.stages) {
            stageIndices = row.data.stages.split("|");
          }
          if (row.data.types) {
            typeIndices = row.data.types.split("|");
          }
          stageIndices.forEach(i => {
            const stage = stages[Number(i) - 1];
            if (stage) {
              rowStages.push(stage);
            }
          });
          typeIndices.forEach(i => {
            const type = types[Number(i) - 1];
            if (type) {
              rowTypes.push(type);
            }
          });
          await this.createResource({
            name: row.data.name,
            city: row.data.city,
            state: row.data.state,
            address: row.data.address,
            zip: row.data.zip,
            phone: row.data.phone,
            email: row.data.email,
            website: row.data.website,
            description: row.data.description,
            stages: rowStages,
            types: rowTypes
          });
        }
      });
      this.dialogUpload = false;
      this.saving = false;
    },
  },
  async mounted() {
    await this.listResources();
    this.loading = false;
  },
};
const stages = [
  "Pre-Diagnosis",
  "Diagnosis",
  "Early Intervention",
  "Schools",
  "College & Vocational",
  "Employment",
  "Housing",
];
const types = [
  "ABA Services",
  "Community Life",
  "Diagnosis",
  "Education Services",
  "Employment",
  "Family Support",
  "Finance and medicaid",
  "Health and medical",
  "Housing",
  "Information",
  "Legal/advocacy",
  "Miscellaneous",
  "School",
  "Therapy",
];
</script>

<style scoped>
.loader {
  margin-top: 20%;
}
</style>
